import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectProps } from '@mui/material/Select';
import classnames from 'classnames';
import merge from 'lodash/merge';
import useStatefulId from '@/lib/hooks/useStatefulId';

export type SingleSelectProps = Omit<SelectProps, 'multiple'> & {
  children: React.ReactNode;
  classes?: {
    formControl?: string;
    label?: string;
    select?: string;
  };
  name: string;
  label: string;
};

function SingleSelect({
  MenuProps = {},
  children,
  classes = {},
  id,
  name,
  label,
  required = false,
  ...props
}: SingleSelectProps) {
  const statefulId = useStatefulId(id);
  const labelId = `${statefulId}-label`;
  const menuProps = React.useMemo(() => {
    return merge(MenuProps, {
      classes: {
        list: classnames(
          'py-0 [&_.MuiMenuItem-root]:px-2.5 [&_.MuiMenuItem-root]:py-3',
          MenuProps?.classes?.list,
        ),
      },
    });
  }, [MenuProps]);

  return (
    <FormControl className={classes?.formControl}>
      <InputLabel
        className={classnames('whitespace-nowrap', classes?.label)}
        id={labelId}
        required={required}
      >
        {label}
      </InputLabel>
      <Select
        MenuProps={menuProps}
        className={classes?.select}
        id={id}
        label={label}
        labelId={labelId}
        name={name}
        required={required}
        {...props}
        multiple={false}
      >
        {children}
      </Select>
    </FormControl>
  );
}

SingleSelect.Item = MenuItem;

export default SingleSelect;
